import { HiClock, HiArrowTopRightOnSquare } from "react-icons/hi2";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import { contactSupport } from "../../../../utils/supportUtils";
import CustomNotificationBanner from "../../../ui/CustomNotificationBanner/CustomNotificationBanner";
import {
  ResultStatusIcon,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";
import { TransactionSummaryRows } from "./TransactionSummaryRows";

export function ProcessingView({
  transactionReference,
  createdDate,
  verifiedAlias,
  aliasLabel,
  accountNumber,
  transactionAmount,
  transactionFee,
  total,
  newBalance,
  onViewTransactions,
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col items-center text-center gap-3">
        <ResultStatusIcon
          icon={HiClock}
          bgClassName="bg-amber-50"
          iconClassName="text-amber-500"
        />
        <div className="space-y-1">
          <p className="text-sm sm:text-base font-semibold text-amber-600">
            Payment Pending
          </p>
          <p className="text-xs sm:text-sm text-gray-500 max-w-xs">
            We couldn&apos;t confirm your payment status. The payment may still
            be processing on the network.
          </p>
        </div>
      </div>

      <div className="w-full">
        <CustomNotificationBanner
          variant="warning"
          title="Status: Processing"
          message="Please check your transaction history for the latest status before retrying."
          withCloseButton={false}
        />
      </div>

      <TransactionDetailsCard>
        <TransactionSummaryRows
          transactionReference={transactionReference}
          createdDate={createdDate}
          verifiedAlias={verifiedAlias}
          aliasLabel={aliasLabel}
          accountNumber={accountNumber}
          transactionAmount={transactionAmount}
          transactionFee={transactionFee}
          total={total}
          newBalance={newBalance}
          balanceLabel="Wallet Balance"
        />
      </TransactionDetailsCard>

      <div className="w-full max-w-sm sm:max-w-md mx-auto grid grid-cols-1 xs:grid-cols-2 gap-2">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          leftSection={<HiArrowTopRightOnSquare style={{ fontSize: 14 }} />}
          onClick={onViewTransactions}
        >
          View in Transactions
        </CustomButton>
        <CustomButton
          fullWidth
          variant="outline"
          color="gray"
          radius="md"
          onClick={() => contactSupport()}
        >
          Contact Support
        </CustomButton>
      </div>
    </div>
  );
}
